const TOPICS = [
  { label: '霸道总裁', count: '128部', hot: true },
  { label: '先婚后爱', count: '96部', hot: true },
  { label: '校园恋爱', count: '215部', hot: true },
  { label: '青梅竹马', count: '87部', hot: false },
  { label: '契约恋爱', count: '73部', hot: true },
  { label: '日久生情', count: '156部', hot: false },
  { label: '甜蜜日常', count: '189部', hot: true },
  { label: '治愈系', count: '142部', hot: false },
  { label: '纯爱无虐', count: '103部', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">当前最受关注的漫画话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {TOPICS.map((topic, idx) => (
            <a
              key={idx}
              href="#topics"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full border text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/70 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
              }`}
            >
              {topic.label}
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                topic.hot ? 'bg-primary-200 text-primary-700' : 'bg-background-100 text-foreground-500'
              }`}>
                {topic.count}
              </span>
              {topic.hot && <i className="ri-fire-fill text-accent-500 text-xs"></i>}
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#topics" className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
            查看全部话题 <i className="ri-hashtag"></i>
          </a>
        </div>
      </div>
    </section>
  );
}